import { toast, ToastContainer } from "react-toastify";
import AddLocations from "./addLocations";
import DataTable from "react-data-table-component";
import PageTitle from "../../components/page-title/pageTitle";
import { useEffect, useState } from "react";
import { MdOutlineEditLocation } from "react-icons/md";
import { get } from "../../utils/fetchAPI";
import { motion, AnimatePresence } from "framer-motion";

const LocationList = () => {
    const [locations, setLocations] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [editLocationData, setEditLocationData] = useState(null);

    useEffect(() => {
        fetchLocations();
    }, []);

    const fetchLocations = async () => {
        try {
            const response = await get("location/list");
            setLocations(response?.data?.organizations || []);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const closePopup = () => setShowPopup(false);

    const handleAddLocationSuccess = () => {
        toast.success("Location added successfully!");
        fetchLocations();
        closePopup();
    };

    const handleEdit = (location) => {
        setEditLocationData(location);
        setShowPopup(true);
    };

    const columns = [
        {
            name: "ID",
            selector: row => row?._id || "-",
            sortable: true,
            grow: 2,
        },
        {
            name: "Organization ID",
            selector: row => row?.organization || "-",
            sortable: true,
            grow: 2,
        },
        {
            name: "Location Name",
            selector: row => row?.name || "-",
            sortable: true,
            grow: 1,
        },
        {
            name: "Phone",
            selector: row =>
                row?.contact?.[0]?.contact?.[0]?.value || "N/A",
            sortable: false,
        },
        {
            name: "Created At",
            selector: row =>
                row?.createdAt
                    ? new Date(row.createdAt).toLocaleDateString()
                    : "-",
            sortable: true,
        },
        {
            name: "Actions",
            center: true,
            width: "120px",
            cell: row => (
                <button
                    onClick={() => handleEdit(row)}
                    className="px-3 py-1 bg-yellow-500 text-white rounded text-sm"
                >
                    Edit
                </button>
            ),
        },
    ];

    /** 🔥 TABLE-LIKE STYLING */
    const customStyles = {
        table: {
            style: {
                border: "1px solid #d1d5db",
                borderRadius: "6px",
            },
        },
        headRow: {
            style: {
                borderBottom: "2px solid #d1d5db",
            },
        },
        headCells: {
            style: {
                backgroundColor: "#f3f4f6",
                color: "#111827",
                fontWeight: "700",
                fontSize: "14px",
                borderRight: "1px solid #d1d5db",
            },
        },
        rows: {
            style: {
                borderBottom: "1px solid #e5e7eb",
            },
            stripedStyle: {
                backgroundColor: "#f9fafb",
            },
        },
        cells: {
            style: {
                fontSize: "13px",
                color: "#111827",
                borderRight: "1px solid #e5e7eb",
                paddingTop: "10px",
                paddingBottom: "10px",
            },
        },
        pagination: {
            style: {
                borderTop: "1px solid #d1d5db",
            },
        },
    };

    return (
        <div className="flex justify-center flex-col gap-5 w-full h-full">
            {/* Header */}
            <div className="flex justify-between items-center">
                <PageTitle icon={MdOutlineEditLocation} title="Location List" />
                <button
                    onClick={() => {
                        setEditLocationData(null);
                        setShowPopup(true);
                    }}
                    className="text-sm px-4 py-2 bg-primary text-white rounded-md"
                >
                    Add Location
                </button>
            </div>

            {/* TABLE */}
            <DataTable
                columns={columns}
                data={locations}
                pagination
                striped
                highlightOnHover
                persistTableHead
                customStyles={customStyles}
                noDataComponent={
                    <div className="py-6 text-gray-500 text-sm">
                        No data found
                    </div>
                }
            />

            {/* MODAL */}
            <AnimatePresence>
                {showPopup && (
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50">
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0 }}
                            className="bg-white p-5 rounded-md shadow-lg w-[600px]"
                        >
                            <AddLocations
                                onClose={closePopup}
                                onAddLocation={fetchLocations}
                                initialData={editLocationData}
                                onAddLocationSuccess={handleAddLocationSuccess}
                            />
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            {/* TOAST */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                style={{ zIndex: 99999 }}
            />
        </div>
    );
};

export default LocationList;
